import React from "react";

/**
 * Brand logo lockup.
 * Variants:
 *   - "icon"  : just the mark (default 32px)
 *   - "lockup": mark + "Golf Eclectic" wordmark (default 32px mark)
 *
 * The PNG is rendered as a transparent image so it sits cleanly on any surface.
 */
export default function Logo({
  variant = "lockup",
  size = 32,
  className = "",
  wordmarkClassName = "text-[15px] font-semibold tracking-tight text-ink",
  alt = "Golf Eclectic",
}) {
  const mark = (
    <img
      src="/logo.png"
      alt={alt}
      width={size}
      height={size}
      className="block select-none"
      style={{ width: size, height: size }}
      draggable={false}
    />
  );

  if (variant === "icon") {
    return <span className={className}>{mark}</span>;
  }

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      {mark}
      <span className={wordmarkClassName}>Golf Eclectic</span>
    </span>
  );
}
